import styled from 'styled-components'

export const Button = styled.button`
    position: relative;
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

export const Counter = styled.span`
    position: absolute;
    top: -0.1rem;
    right: -0.1rem;
    background-color: #fff;
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    width: 1.125rem;
    height: 1.125rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #000e40;
    color: #000e40;
`

export const Icon = styled.img`
    width: 2rem;
    height: 2rem;
`
